import {
  ADOPTION_CHANGE_VALUES,
} from '@/store/constants/mutationTypes';

const mutations = {
  [ADOPTION_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      if (state[field] !== undefined) {
        state[field] = value;
      }
    });
  },
};

export default mutations;
